<body class="adl">
  <!-- Table header -->
  <app-table-header
    [headerText]="CONSTANTS.WELCOME_TEXT"
    [hasFilter]="false"
    [hasAddItem]="false"
    [hasSearchBar]="true"
    [hasCollapsedPadding]="false"
    [hasAltHeader]="true"
    (searchEvent)="search($event)"
    (searchClear)="clearSearch()"
    (exportExcelEvent)="exportExcel()"
  ></app-table-header>
  <div class="adl-table-container">
    <cdk-virtual-scroll-viewport itemSize="50">
      <table mat-table [dataSource]="dataSource" class="adl-table">
        <!-- Route -->
        <ng-container matColumnDef="loop">
          <th mat-header-cell *matHeaderCellDef>
            <ion-row class="th-text">
              {{ COLUMNTEXT.ROUTE }}
            </ion-row>
          </th>

          <ng-container mat-cell *matCellDef="let admin; let rowIndex = index">
            @if (admin.displayLoop) {
              <td
                class="route-border left-data-column"
                headers="route-header"
                [attr.rowspan]="getRowSpan(admin)"
                [ngClass]="{
                  'background-color-grey': admin.index % 2 !== 0,
                }"
              >
                {{ getRouteIdText(admin, accessPointDetail) }}
              </td>
            }
          </ng-container>
        </ng-container>

        <!-- Access Points -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            <ion-row class="th-text">
              {{ COLUMNTEXT.ACCESS }}
            </ion-row>
          </th>
          <td
            mat-cell
            *matCellDef="let admin; let i = index"
            [ngClass]="{
              'background-color-grey': admin.index % 2 !== 0,
            }"
            headers="access-point-header"
            class="left-data-column"
          >
            <ion-row>
              <ion-col>
                <a
                  class="access-point"
                  (click)="
                    openAdlSummary(admin.loop, admin.uapPublicId, admin.id)
                  "
                >
                  {{ admin.name }}
                </a>
              </ion-col>
            </ion-row>
          </td>
        </ng-container>

        <!-- UAP -->
        <ng-container matColumnDef="uapPublicId">
          <th mat-header-cell *matHeaderCellDef>
            <ion-row class="th-text">
              {{ COLUMNTEXT.UAP }}
            </ion-row>
          </th>

          <td
            headers="uap-headers"
            mat-cell
            *matCellDef="let admin"
            [ngClass]="{
              'background-color-grey': admin.index % 2 !== 0,
            }"
            class="left-data-column"
          >
            <ion-row>
              <ion-col>
                {{ admin.uapPublicId }}
              </ion-col>
            </ion-row>
          </td>
        </ng-container>

        <!-- Availability-->
        <ng-container matColumnDef="hoursOfOperation">
          <th mat-header-cell *matHeaderCellDef>
            <ion-row class="th-text">
              {{ COLUMNTEXT.AVAILABILITY }}
            </ion-row>
          </th>

          <td
            headers="availability-headers"
            mat-cell
            *matCellDef="let admin"
            [ngClass]="{
              'background-color-grey': admin.index % 2 !== 0,
            }"
          >
            <div class="day-row">
              @for (data of admin.hoursOfOperation; track data) {
                <div class="availability-data">
                  <div class="day" [ngClass]="{ 'available-day': data.value }">
                    {{ data.day }}
                  </div>
                </div>
              }
            </div>
          </td>
        </ng-container>

        <!-- City -->
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>
            <ion-row class="th-text">
              {{ COLUMNTEXT.CITY }}
            </ion-row>
          </th>

          <td
            headers="city-headers"
            mat-cell
            *matCellDef="let admin"
            [ngClass]="{
              'background-color-grey': admin.index % 2 !== 0,
            }"
            class="left-data-column"
          >
            <ion-row>
              <ion-col>
                {{ admin.city }}
              </ion-col>
            </ion-row>
          </td>
        </ng-container>

        <!-- Contact-->
        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef>
            <ion-row class="th-text">
              {{ COLUMNTEXT.CONTACT }}
            </ion-row>
          </th>

          <td
            headers="contact-headers"
            mat-cell
            *matCellDef="let admin"
            [ngClass]="{
              'background-color-grey': admin.index % 2 !== 0,
            }"
            class="left-data-column"
          >
            <ion-row>
              <ion-col>
                {{ admin.phoneNumber }}
              </ion-col>
            </ion-row>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="uapStatus">
          <th mat-header-cell *matHeaderCellDef>
            <ion-row class="th-text">
              {{ COLUMNTEXT.STATUS }}
            </ion-row>
          </th>

          <td
            headers="status-headers"
            mat-cell
            *matCellDef="let admin"
            [ngClass]="{
              'background-color-grey': admin.index % 2 !== 0,
            }"
            class="left-data-column"
          >
            <ion-row>
              <ion-col>
                {{ admin.uapStatus }}
              </ion-col>
            </ion-row>
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>
            <ion-row class="th-text center-text">
              {{ COLUMNTEXT.ACTIONS }}
            </ion-row>
          </th>

          <ng-container mat-cell *matCellDef="let admin; let i = index">
            @if (admin.displayLoop) {
              <td
                class="actions-cell"
                headers="action-headers"
                [attr.rowspan]="getRowSpan(admin)"
                [ngClass]="{
                  'background-color-grey': admin.index % 2 !== 0,
                }"
              >
                <button
                  class="button-for-icons"
                  (click)="editAccessPoint(admin.index)"
                >
                  <img [src]="IMAGES.EDIT_BLUE" alt="edit" />
                </button>
              </td>
            }
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="IDS; sticky: true"></tr>

        <tr mat-row *matRowDef="let row; columns: IDS; let i = index"></tr>

        <tr class="mat-row no-results" *matNoDataRow>
          <td class="mat-cell no-border" [attr.colspan]="IDS.length">
            <app-no-results-found></app-no-results-found>
          </td>
        </tr>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>
</body>
